<template>
  <defs>
    <!--
      NOTE (mpetrov):
      1. need to use relative paths https://github.com/oliverfindl/vue-svg-inline-loader/issues/2
      2. There is no need to mount all the sprites but we easily can
      <img
        svg-inline
        src="../../../node_modules/@uikit/ui-syntax/dist/icon-sprite/iconsprite.svg"
      />
    -->
    <svg
      id="m-ips-o--16"
      viewBox="0 0 16 16"
      width="16"
      height="16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM5 5H6.54236V10.6967H5V5ZM10.0803 4.97632H7.79089V5H7.78638V10.6967H9.32874V8.8197H10.0803C11.1416 8.8197 12.002 7.95933 12.002 6.89801C12.002 5.83669 11.1416 4.97632 10.0803 4.97632ZM9.1886 6.25195H9.83099C10.1878 6.25195 10.4771 6.5412 10.4771 6.89801C10.4771 7.25482 10.1878 7.54407 9.83099 7.54407H9.1886V6.25195Z"
            :fill="avBrandPrimary"
      />
    </svg>
    <svg
      id="m-ips-o--24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM9.63379 16.995H8V7.00586H9.63379V16.995ZM12.9062 16.995H11.2725V7.00586H14.1504C15.3991 7.00586 16.3345 7.26107 16.9565 7.77148C17.5786 8.2819 17.8896 9.03385 17.8896 10.0273C17.8896 11.071 17.5479 11.8708 16.8643 12.4268C16.1807 12.9827 15.2077 13.2607 13.9453 13.2607H12.9062V16.995ZM13.7744 11.8867H12.9062V8.37305H14.041C14.7839 8.37305 15.3307 8.51432 15.6816 8.79688C16.0326 9.07943 16.208 9.50781 16.208 10.082C16.208 10.7018 16.012 11.1576 15.6201 11.4492C15.2282 11.7409 14.613 11.8867 13.7744 11.8867Z"
            :fill="avBrandPrimary"
            :fill-opacity="0.3"
      />
    </svg>

    <svg
      id="m-traffic type-o--16--16"
      viewBox="0 0 16 16"
      :width="16"
      :height="16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd"
            clip-rule="evenodd" xmlns="http://www.w3.org/2000/svg" d="M5.70711 0.292893C6.09763 0.683417 6.09763 1.31658 5.70711 1.70711L4.41421 3H14C14.5523 3 15 3.44772 15 4C15 4.55228 14.5523 5 14 5H4.41421L5.70711 6.29289C6.09763 6.68342 6.09763 7.31658 5.70711 7.70711C5.31658 8.09763 4.68342 8.09763 4.29289 7.70711L1.29289 4.70711C0.902369 4.31658 0.902369 3.68342 1.29289 3.29289L4.29289 0.292893C4.68342 -0.0976311 5.31658 -0.0976311 5.70711 0.292893Z" :fill="avBrandPrimary"/>
      <path fill-rule="evenodd"
            clip-rule="evenodd" xmlns="http://www.w3.org/2000/svg" d="M10.2929 15.7071C9.90237 15.3166 9.90237 14.6834 10.2929 14.2929L11.5858 13H2C1.44771 13 1 12.5523 1 12C1 11.4477 1.44772 11 2 11H11.5858L10.2929 9.70711C9.90237 9.31658 9.90237 8.68342 10.2929 8.29289C10.6834 7.90237 11.3166 7.90237 11.7071 8.29289L14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071L11.7071 15.7071C11.3166 16.0976 10.6834 16.0976 10.2929 15.7071Z" :fill="avBrandPrimary"/>
    </svg>
    <svg
      id="m-folder-o--24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 10L18 10"
        stroke-width="2"
        stroke-linecap="round"
        :stroke="avBrandPrimary"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3 5C3 4.44772 3.44772 4 4 4H7.67612C7.98821 4 8.28241 4.14571 8.47155 4.39396L9.17568 5.31813C9.7431 6.06287 10.6257 6.5 11.562 6.5H17.5H20C20.5523 6.5 21 6.94771 21 7.5V19C21 19.5522 20.5523 20 20 20H4C3.44771 20 3 19.5522 3 19V9V8.48145V5ZM1 8.48145V5C1 3.34315 2.34315 2 4 2H7.67612C8.6124 2 9.49499 2.43713 10.0624 3.18187L10.7665 4.10604C10.9557 4.35429 11.2499 4.5 11.562 4.5H17.5H20C21.6569 4.5 23 5.84314 23 7.5V19C23 20.6568 21.6569 22 20 22H4C2.34315 22 1 20.6568 1 19V9V8.48145Z"
        :fill="avBrandPrimary"
      />
    </svg>
    <svg
      id="m-file-o--24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 20V4L12 4V8C12 9.10457 12.8954 10 14 10H18V20H6ZM16.8166 8L14 4.94863V8H16.8166ZM4 20V4C4 2.89543 4.89543 2 6 2H13.1243C13.6825 2 14.2153 2.23327 14.5939 2.64344L19.4696 7.92541C19.8106 8.29485 20 8.77919 20 9.28197V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20Z"
        :fill="avBrandPrimary"
      />
    </svg>
    <svg
      id="m-pending-o--24"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3189_12449)">
        <circle
          cx="8"
          cy="8"
          r="8"
          fill-opacity="0.3"
          :fill="avBrandLight"
        />
        <circle
          cx="8"
          cy="8"
          r="7.5"
          stroke-opacity="0.1"
          :stroke="avBrandPrimary"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8 3C8.55228 3 9 3.44772 9 4V7.58579L11.2071 9.79289C11.5976 10.1834 11.5976 10.8166 11.2071 11.2071C10.8166 11.5976 10.1834 11.5976 9.79289 11.2071L7.58579 9C7.21071 8.62493 7 8.11622 7 7.58579V4C7 3.44772 7.44772 3 8 3Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3189_12449">
          <rect
          width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
    <svg
      id="m-create-container--24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14.8252 16.0001C15.2577 16.0001 15.6579 16.0576 16.0254 16.1729C16.3928 16.286 16.7161 16.4524 16.9951 16.6719C17.2742 16.8893 17.5014 17.1565 17.6758 17.4737C17.7025 17.5224 17.7273 17.5723 17.751 17.6231C17.9711 18.0963 17.5463 18.5616 17.0244 18.5616H16.7422C16.4635 18.5616 16.2417 18.3465 16.1123 18.0997C16.0402 17.9622 15.9448 17.8447 15.8262 17.7471C15.7076 17.6496 15.5671 17.5745 15.4043 17.5235C15.244 17.4704 15.0662 17.4435 14.8711 17.4434C14.5247 17.4434 14.2257 17.5248 13.9746 17.6866C13.7258 17.8485 13.5333 18.0827 13.3984 18.3887C13.2659 18.6948 13.1992 19.0653 13.1992 19.5001C13.1992 19.9525 13.2675 20.3317 13.4023 20.6378C13.5395 20.9415 13.7311 21.171 13.9775 21.3262C14.2264 21.4793 14.5208 21.5557 14.8604 21.5557C15.0509 21.5557 15.2241 21.5329 15.3799 21.4864C15.5379 21.4398 15.6764 21.3719 15.7949 21.2833C15.9158 21.1924 16.0151 21.0827 16.0918 20.9542C16.2338 20.7192 16.4559 20.5122 16.7305 20.5137L17.0605 20.5157C17.5642 20.5186 17.9585 20.9671 17.7246 21.4132C17.5734 21.7059 17.3647 21.9732 17.0996 22.2149C16.8345 22.4544 16.5112 22.6453 16.1299 22.7872C15.7508 22.9291 15.3158 23.0001 14.8252 23.0001C14.1787 23 13.5995 22.8644 13.0879 22.5938C12.5787 22.321 12.1762 21.9244 11.8809 21.4034C11.5855 20.8822 11.4375 20.2475 11.4375 19.5001C11.4375 18.7505 11.5878 18.115 11.8877 17.5938C12.1877 17.0727 12.5939 16.6769 13.1055 16.4063C13.6171 16.1357 14.1903 16.0001 14.8252 16.0001Z" :fill="avBrandPrimary"/>
      <path d="M23.3311 16.0928C23.7004 16.0928 24 16.3925 24 16.7618C24 17.1311 23.7004 17.4307 23.3311 17.4307H21.834V22.0557C21.8339 22.5258 21.4525 22.9073 20.9824 22.9073C20.5123 22.9073 20.1309 22.5258 20.1309 22.0557V17.4307H18.6299C18.2606 17.4307 17.9609 17.1311 17.9609 16.7618C17.961 16.3925 18.2606 16.0929 18.6299 16.0928H23.3311Z" :fill="avBrandPrimary"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4854 1.14264C11.802 0.952635 12.198 0.952635 12.5146 1.14264L21.5146 6.14264C21.8157 6.32339 22 6.64887 22 7.00007V13.9395C22 14.4918 21.5523 14.9395 21 14.9395C20.4477 14.9395 20 14.4918 20 13.9395V8.79499L13 12.4747V14.9395C13 15.4918 12.5523 15.9395 12 15.9395C11.4477 15.9395 11 15.4918 11 14.9395V12.4747L4 8.79499V16.4112L10.5088 20.213C10.8128 20.3906 10.9999 20.7163 11 21.0684C11 21.8317 10.1733 22.309 9.5127 21.9268L2.48535 17.8575C2.18423 17.6768 2.00002 17.3513 2 17.0001V7.00007C2 6.64887 2.18425 6.32339 2.48535 6.14264L11.4854 1.14264ZM4.99414 7.03522L12 10.7178L19.0049 7.0362L12 3.1446L4.99414 7.03522Z" :fill="avBrandPrimary"/>
    </svg>
    <svg
      id="m-bucket-icon-o--16"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2323 13.0534C12.3514 13.0534 14.0003 2.76649 14.0003 2.71554C14.0003 1.82338 11.314 1 8.00027 1C4.68656 1 2.00049 1.82338 2.00049 2.71554C2.00049 2.76649 3.82931 13.3349 3.84645 13.3846C3.84645 14.2768 5.70616 15 8.00027 15C10.2944 15 12.1541 14.2768 12.1541 13.3846L12.2323 13.0534Z"
        :stroke="avBrandPrimary"
        stroke-width="2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.68443 5.1706C4.75272 5.20379 4.82144 5.23513 4.89026 5.26475C5.74282 5.6316 6.84247 5.83124 8.00042 5.83124C9.15837 5.83124 10.258 5.6316 11.1106 5.26475C11.1792 5.2352 11.2478 5.20394 11.3159 5.17084C11.6039 5.03089 11.7666 4.7107 11.7666 4.38415C11.7666 4.0142 11.569 3.73409 11.343 3.58281C11.1188 3.43273 10.8217 3.37591 10.5453 3.49087C9.90251 3.75814 9.00528 3.93009 8.00042 3.93009C6.9954 3.93009 6.09806 3.75809 5.45528 3.49075C5.1788 3.37576 4.8817 3.43259 4.6575 3.58264C4.4315 3.73391 4.23389 4.01402 4.23389 4.38401C4.23389 4.7105 4.39648 5.03064 4.68443 5.1706Z"
        :fill="avBrandPrimary"
      />
    </svg>
    <svg
      id="m-bucket-icon-o--24"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9999 0H12H12.0001C14.0981 0 16.0774 0.235762 17.7381 0.657583C19.323 1.06015 20.8911 1.69969 21.8958 2.70055C22.6646 3.46653 22.8632 4.39748 22.8822 5.1034C22.8997 5.75541 22.7674 6.38692 22.6891 6.76065L22.6867 6.77192C22.2508 8.85314 21.562 12.6961 21.123 15.1457L21.1229 15.1459L21.1229 15.146L21.1229 15.1461C20.9747 15.9729 20.855 16.641 20.7831 17.0288C20.752 17.1961 20.7159 17.3751 20.6838 17.5337L20.6838 17.534L20.6836 17.5348C20.6695 17.6045 20.6562 17.6702 20.6446 17.7293L20.2659 19.6418C19.9395 21.4508 18.5108 22.539 17.1209 23.1264C15.6897 23.7311 13.9004 24 12.0001 24H12H11.9999C10.0996 24 8.31034 23.7311 6.87912 23.1264C5.48922 22.539 4.06048 21.4508 3.73413 19.6418L3.35544 17.7293C3.34377 17.6703 3.3305 17.6046 3.31643 17.535L3.31624 17.534L3.31617 17.5337C3.28413 17.3751 3.24796 17.1961 3.21693 17.0288C3.14501 16.641 3.02532 15.9732 2.87717 15.1465L2.87709 15.1461L2.87706 15.146L2.87706 15.1459L2.87705 15.1459C2.43803 12.6963 1.74926 8.8532 1.31326 6.77192L1.3109 6.76065C1.23259 6.38692 1.10027 5.75541 1.11779 5.1034C1.13675 4.39748 1.33535 3.46653 2.10424 2.70055C3.1089 1.69969 4.67701 1.06015 6.2619 0.657583C7.9226 0.235762 9.90191 0 11.9999 0ZM12 22H12.0001C15.4795 22 18.0001 21 18.3001 19.2727L18.6826 17.3408C18.6976 17.2654 18.7127 17.1904 18.7279 17.1156L18.7279 17.1155L18.7279 17.1154C18.7582 16.9653 18.7885 16.8157 18.8166 16.6641C18.8849 16.2956 19.0008 15.649 19.1455 14.8419L19.1458 14.8402L19.1458 14.8401C19.5842 12.394 20.2863 8.47601 20.7292 6.36186C20.8945 5.57268 21.0555 4.6865 20.4842 4.11744C19.2457 2.8836 15.9148 2 12.0001 2H12H11.9999C8.08521 2 4.75429 2.8836 3.51577 4.11744C2.94455 4.6865 3.10545 5.57268 3.27077 6.36186C3.71365 8.47602 4.41583 12.3941 4.85421 14.8401L4.85421 14.8402C4.999 15.648 5.11501 16.2954 5.1834 16.6641C5.21153 16.8157 5.24176 16.9653 5.27211 17.1155L5.27214 17.1156C5.28727 17.1904 5.30242 17.2654 5.31735 17.3408L5.69987 19.2727C5.99988 21 8.52048 22 11.9999 22H12Z"
        :fill="avBrandPrimary"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 7.00664C5 7.33492 5.1835 7.63832 5.48506 7.76806C5.61492 7.82393 5.74615 7.87693 5.87814 7.92721C7.52534 8.55472 9.68963 8.90852 12 8.90852C14.3104 8.90852 16.4747 8.55472 18.1219 7.92721C18.2539 7.87693 18.3851 7.82393 18.5149 7.76806C18.8165 7.63832 19 7.33492 19 7.00664C19 6.29286 18.1418 5.81938 17.472 6.06598C16.0551 6.5876 14.126 6.90852 12 6.90852C9.87405 6.90852 7.94485 6.5876 6.52803 6.06598C5.85821 5.81938 5 6.29286 5 7.00664Z"
        :fill="avBrandPrimary"
      />
    </svg>
    <svg
      id="m-bucket-empty-o--24"
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M35.9996 0H36V6H35.9996C24.2556 6 14.2629 8.6508 10.5473 12.3523C8.83365 14.0595 9.31635 16.718 9.81232 19.0856C11.141 25.428 13.2475 37.1822 14.5626 44.5204L14.5626 44.5204C14.997 46.9441 15.345 48.8861 15.5502 49.9922C15.6346 50.4473 15.7253 50.8962 15.8164 51.3467L15.8164 51.3468L15.8165 51.347L15.8165 51.3472C15.8619 51.5715 15.9073 51.7963 15.9521 52.0224L17.0996 57.8182C17.9996 63 25.5614 66 35.9996 66H36V72H35.9996C30.2987 72 24.931 71.1934 20.6374 69.3791C16.4676 67.6171 12.1815 64.3525 11.2024 58.9255L10.0663 53.1878C10.0312 53.0103 9.99121 52.8125 9.94883 52.6027L9.94861 52.6016L9.94851 52.6011L9.9485 52.6011L9.94848 52.6009C9.85237 52.1252 9.74386 51.5881 9.6508 51.0864C9.43501 49.9229 9.07586 47.919 8.63134 45.4388L8.63119 45.4379C7.31415 38.0893 5.24778 26.5597 3.93979 20.3158L3.9327 20.2819C3.69778 19.1608 3.30082 17.2662 3.35337 15.3102C3.41026 13.1925 4.00606 10.3996 6.31272 8.10164C9.32669 5.09907 14.031 3.18044 18.7857 1.97275C23.7678 0.707286 29.7057 0 35.9996 0ZM36.0003 0H36V6H36.0003C47.7443 6 57.7371 8.6508 61.4526 12.3523C63.1663 14.0595 62.6836 16.718 62.1876 19.0856C60.859 25.428 58.7525 37.1822 57.4373 44.5204L57.4373 44.5204C57.003 46.9441 56.6549 48.8861 56.4498 49.9922C56.3654 50.4473 56.2746 50.8962 56.1836 51.3467L56.1835 51.3468L56.1835 51.347L56.1826 51.3512C56.1376 51.5742 56.0924 51.7977 56.0479 52.0224L54.9003 57.8182C54.0003 63 46.4385 66 36.0003 66H36V72H36.0003C41.7013 72 47.0689 71.1934 51.3626 69.3791C55.5323 67.6171 59.8185 64.3525 60.7976 58.9255L61.9336 53.1878C61.9687 53.0105 62.0086 52.813 62.0509 52.6035L62.0513 52.6016L62.0514 52.6011L62.0514 52.6011L62.0516 52.6005C62.1476 52.1249 62.2561 51.588 62.3492 51.0864C62.5649 49.9229 62.9241 47.919 63.3686 45.4388L63.3688 45.4379C64.6858 38.0893 66.7522 26.5597 68.0602 20.3158L68.0672 20.2819C68.3022 19.1608 68.6991 17.2662 68.6466 15.3102C68.5897 13.1925 67.9939 10.3996 65.6872 8.10164C62.6733 5.09907 57.9689 3.18044 53.2142 1.97275C48.2321 0.707286 42.2942 0 36.0003 0Z"
        :fill="avBrandLight"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15 21.0199C15 22.0048 15.5505 22.915 16.4552 23.3042C16.8448 23.4718 17.2384 23.6308 17.6344 23.7816C22.576 25.6642 29.0689 26.7256 36 26.7256C42.9311 26.7256 49.424 25.6642 54.3656 23.7816C54.7616 23.6308 55.1552 23.4718 55.5448 23.3042C56.4495 22.915 57 22.0048 57 21.0199V21.0199C57 18.8786 54.4254 17.4581 52.4159 18.1979C48.1654 19.7628 42.3779 20.7256 36 20.7256C29.6221 20.7256 23.8346 19.7628 19.5841 18.1979C17.5746 17.4581 15 18.8786 15 21.0199V21.0199Z"
        :fill="avBrandLight"
      />
    </svg>
    <svg
      id="m-bucket-check-o--24"
      fill="none"
      width="72"
      height="72"
      viewBox="0 0 72 72"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M29.12 24.88a3 3 0 1 0-4.24 4.24l12 12a3 3 0 0 0 4.24 0l30-30a3 3 0 1 0-4.24-4.24L39 34.76z" :fill="avBrandPrimary" fill-opacity=".3"/>
      <path d="M52.87 1.97A71 71 0 0 0 35.65 0c-6.3 0-12.23.7-17.21 1.97C13.68 3.18 8.98 5.1 5.96 8.1A10.4 10.4 0 0 0 3 15.31c-.05 1.96.35 3.85.58 4.97l.01.04c1.3 6.24 3.38 17.77 4.7 25.12l1.01 5.65.3 1.51.12.59 1.13 5.74c.98 5.42 5.27 8.69 9.44 10.45 4.3 1.81 9.66 2.62 15.36 2.62s11.07-.8 15.36-2.62c4.17-1.76 8.46-5.03 9.44-10.45l1.13-5.74.12-.58.3-1.52 1.02-5.64v-.01c.92-5.14 2.2-12.31 3.34-18.3.23-1.16-1.2-1.92-2.04-1.08l-4.48 4.48q-.26.27-.33.63c-.88 4.73-1.75 9.61-2.42 13.35l-1.26 6.83-.13.67-1.15 5.8C53.65 63 46.1 66 35.65 66s-18-3-18.9-8.18l-1.15-5.8-.13-.67-.27-1.36-.99-5.47a1137 1137 0 0 0-4.75-25.43c-.5-2.37-.97-5.03.74-6.74C13.9 8.65 23.9 6 35.65 6c7.6 0 14.46 1.1 19.37 2.9.45.16.95.05 1.29-.28l2.8-2.81c.59-.58.42-1.56-.33-1.88a42 42 0 0 0-5.91-1.96" :fill="avBrandPrimary" fill-opacity=".3"/>
    </svg>
    <svg
      id="m-drs-policy-o--24"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M18 4H19.001C20.109 4 21 4.89476 21 5.99996V10.5815C20.369 10.3261 19.6981 10.1489 18.9991 10.0618C18.9996 7.75368 19 6 19 6H18V7C18 7.55228 17.5523 8 17 8H7C6.44772 8 6 7.55228 6 7V6H5L5 21L10.5815 21C10.8753 21.7257 11.2724 22.3984 11.7546 23H5.00087C3.89321 23 3 22.1055 3 21V5.99996C3 4.9013 3.89606 4 4.99896 4H6C6 3.44772 6.44772 3 7 3H8V2C8 1.44772 8.44772 1 9 1H15C15.5523 1 16 1.44772 16 2V3H17C17.5523 3 18 3.44772 18 4ZM19.4891 22.9392C19.3323 22.9789 19.1681 23 18.9991 23H14.6822C13.9121 22.488 13.2671 21.8028 12.8027 21L16.4882 21C17.4836 21.9272 18.5281 22.7189 19.4891 22.9392ZM16 6H8V5C9.10769 5 10 4.10531 10 3H14C14 4.10769 14.8947 5 16 5V6Z" :fill="avBrandPrimary"/>
      <rect x="7" y="10" width="8" height="2" rx="1" :fill="avBrandPrimary"/>
      <rect x="7" y="14" width="4" height="2" rx="1" :fill="avBrandPrimary"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 18C12 21.3137 14.6863 24 18 24C21.3137 24 24 21.3137 24 18C24 14.6863 21.3137 12 18 12C14.6863 12 12 14.6863 12 18ZM19.0003 15.0001C19.0003 14.4478 18.5526 14 18.0003 14C17.4481 14 17.0003 14.4476 17.0003 14.9999L17 18.0002C17 18.2654 17.1053 18.5198 17.2929 18.7074L19.293 20.7073C19.6835 21.0978 20.3167 21.0977 20.7072 20.7072C21.0977 20.3167 21.0976 19.6835 20.7071 19.293L19 17.5861L19.0003 15.0001Z" :fill="avBrandPrimary"/>
    </svg>
    <svg
      id="m-share-o--24"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.6244 6.99863L15.4372 4.1858C16.1665 3.45655 18.0626 2.4356 19.8128 4.1858C21.563 5.93601 20.542 7.83207 19.8128 8.56132L15.1247 13.2494C14.3955 13.9786 12.4994 14.9996 10.7492 13.2494" stroke="#282735" stroke-width="2" stroke-linecap="round"/>
      <path d="M11.3756 16.9994L8.56276 19.8122C7.8335 20.5415 5.93745 21.5624 4.18724 19.8122C2.43704 18.062 3.45799 16.166 4.18724 15.4367L8.87529 10.7487C9.60455 10.0194 11.5006 8.99847 13.2508 10.7487" stroke="#282735" stroke-width="2" stroke-linecap="round"/>
    </svg>
    <svg
      id="m-gpu-o--24"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="6" y="19" width="6" height="2" rx="1" :fill="avBrandPrimary"/>
      <rect x="14" y="19" width="6" height="2" rx="1" :fill="avBrandPrimary"/>
      <path d="M1 3H2.5C3.05228 3 3.5 3.44772 3.5 4V21" :stroke="avBrandPrimary" stroke-width="2" stroke-linecap="round"/>
      <path d="M4 6.5H21C22.1046 6.5 23 7.39543 23 8.5V15.5C23 16.6046 22.1046 17.5 21 17.5H4" :stroke="avBrandPrimary" stroke-width="2" stroke-linecap="round"/>
      <circle cx="9.5" cy="12" r="2.5" :stroke="avBrandPrimary" stroke-width="2"/>
      <circle cx="17.5" cy="12" r="2.5" :stroke="avBrandPrimary" stroke-width="2"/>
    </svg>
    <svg
      id="m-gpu-online-o--24"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="6" y="19" width="6" height="2" rx="1" :fill="avBrandPrimary"/>
      <path d="M1 3H2.5C3.05228 3 3.5 3.44772 3.5 4V21" :stroke="avBrandPrimary" stroke-width="2" stroke-linecap="round"/>
      <circle cx="9.5" cy="12" r="2.5" :stroke="avBrandPrimary" stroke-width="2"/>
      <circle cx="17.5" cy="12" r="2.5" :stroke="avBrandPrimary" stroke-width="2"/>
      <circle cx="20" cy="20" r="4" fill="#9BC225"/>
      <circle cx="20" cy="20" r="3.5" stroke="#243143" stroke-opacity="0.1"/>
      <path d="M15.1279 16.5C14.6999 17.0947 14.3764 17.77 14.1885 18.5H4C3.44772 18.5 3 18.0523 3 17.5C3 16.9477 3.44772 16.5 4 16.5H15.1279ZM21 5.5C22.6569 5.5 24 6.84315 24 8.5V15.5C24 15.5095 23.9991 15.5189 23.999 15.5283C23.422 15.012 22.7451 14.6052 22 14.3418V8.5C22 7.94772 21.5523 7.5 21 7.5H4C3.44772 7.5 3 7.05228 3 6.5C3 5.94772 3.44772 5.5 4 5.5H21Z" :fill="avBrandPrimary"/>
    </svg>

    <svg
      id="m-gpu-offline-o--24"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="6" y="19" width="6" height="2" rx="1" :fill="avBrandLight"/>
      <path d="M1 3H2.5C3.05228 3 3.5 3.44772 3.5 4V21" :stroke="avBrandLight" stroke-width="2" stroke-linecap="round"/>
      <circle cx="9.5" cy="12" r="2.5" :stroke="avBrandLight" stroke-width="2"/>
      <circle cx="17.5" cy="12" r="2.5" :stroke="avBrandLight" stroke-width="2"/>
      <circle cx="20" cy="20" r="4" :fill="avBrandLight"/>
      <path d="M15.1279 16.5C14.6999 17.0947 14.3764 17.77 14.1885 18.5H4C3.44772 18.5 3 18.0523 3 17.5C3 16.9477 3.44772 16.5 4 16.5H15.1279ZM21 5.5C22.6569 5.5 24 6.84315 24 8.5V15.5C24 15.5095 23.9991 15.5189 23.999 15.5283C23.422 15.012 22.7451 14.6052 22 14.3418V8.5C22 7.94772 21.5523 7.5 21 7.5H4C3.44772 7.5 3 7.05228 3 6.5C3 5.94772 3.44772 5.5 4 5.5H21Z" :fill="avBrandLight"/>
    </svg>
    <svg
      id="m-vhs--24"
      width="72"
      height="88"
      viewBox="0 0 72 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.1541 2.5454L66.231 18.4525C67.923 19.3782 67.923 21.8306 66.231 22.7562L37.1541 38.6633C36.4341 39.0572 35.5659 39.0572 34.8459 38.6633L5.76901 22.7562C4.077 21.8306 4.077 19.3782 5.76901 18.4525L34.8459 2.5454C35.5659 2.15153 36.4341 2.15153 37.1541 2.5454ZM36 7.48045L12.0105 20.6044L36 33.7283L59.9894 20.6044L36 7.48045ZM67.5 20.6044V53.6422C67.5 54.5403 67.0129 55.3663 66.231 55.7941L37.1541 71.7012C35.5396 72.5844 33.5769 71.4038 33.5769 69.5493V36.5115C33.5769 35.6133 34.064 34.7874 34.8459 34.3596L63.9228 18.4525C65.5373 17.5693 67.5 18.7499 67.5 20.6044ZM62.6538 24.7132L38.4231 37.9691V65.4405L62.6538 52.1846V24.7132ZM8.07715 18.4525L22.6156 26.4061L37.1541 34.3596C37.936 34.7874 38.4231 35.6133 38.4231 36.5115V69.5493C38.4231 71.4038 36.4604 72.5844 34.8459 71.7012L5.76901 55.7941C4.9871 55.3663 4.5 54.5403 4.5 53.6422V20.6044C4.5 18.7499 6.46265 17.5693 8.07715 18.4525ZM9.34615 24.7132V52.1846L33.5769 65.4405V37.9691L9.34615 24.7132Z"
        fill-opacity="0.3"
        :fill="avBrandPrimary"
      />
      <path
        opacity="0.8"
        d="M34.9159 17.5961C35.591 17.2249 36.409 17.2249 37.0841 17.5961L53.0206 26.3589C53.7397 26.7543 54.1865 27.5099 54.1865 28.3305V45.6695C54.1865 46.4901 53.7397 47.2457 53.0206 47.6411L37.0841 56.4039C36.409 56.7751 35.591 56.7751 34.9159 56.4039L18.9794 47.6411C18.2603 47.2457 17.8135 46.4901 17.8135 45.6695V28.3305C17.8135 27.5099 18.2603 26.7543 18.9794 26.3589L34.9159 17.5961Z"
        fill-opacity="0.3"
        :fill="avBrandPrimary"
      />
    </svg>
    <svg
      id="m-vhs-o--32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path opacity="0.6" d="M15.524 9.25765C15.821 9.0969 16.179 9.0969 16.476 9.25765L22.4042 12.4664C22.7271 12.6411 22.9282 12.9787 22.9282 13.3458V19.6542C22.9282 20.0213 22.7271 20.3589 22.4042 20.5336L16.476 23.7424C16.179 23.9031 15.821 23.9031 15.524 23.7424L9.59579 20.5336C9.27294 20.3589 9.0718 20.0213 9.0718 19.6542V13.3458C9.0718 12.9787 9.27294 12.6411 9.59579 12.4664L15.524 9.25765Z" fill="currentColor" />
      <path d="M16.5129 1.13129L29.436 8.20112C30.188 8.61252 30.188 9.70247 29.436 10.1139L16.5129 17.1837C16.1929 17.3587 15.8071 17.3587 15.4871 17.1837L2.564 10.1139C1.812 9.70247 1.812 8.61252 2.564 8.20112L15.4871 1.13129C15.8071 0.956237 16.1929 0.956237 16.5129 1.13129ZM16 3.32464L5.33802 9.15749L16 14.9903L26.662 9.15749L16 3.32464ZM30 9.15749V23.841C30 24.2401 29.7835 24.6072 29.436 24.7974L16.5129 31.8672C15.7954 32.2597 14.9231 31.735 14.9231 30.9108V16.2273C14.9231 15.8282 15.1396 15.4611 15.4871 15.2709L28.4102 8.20112C29.1277 7.80857 30 8.33329 30 9.15749ZM27.8462 10.9836L17.0769 16.8751V29.0847L27.8462 23.1932V10.9836ZM3.58984 8.20112L10.0514 11.736L16.5129 15.2709C16.8604 15.4611 17.0769 15.8282 17.0769 16.2273V30.9108C17.0769 31.735 16.2046 32.2597 15.4871 31.8672L2.564 24.7974C2.21649 24.6072 2 24.2401 2 23.841V9.15749C2 8.33329 2.87229 7.80857 3.58984 8.20112ZM4.15385 10.9836V23.1932L14.9231 29.0847V16.8751L4.15385 10.9836Z" fill="currentColor" />
    </svg>
    <svg
      id="m-key-2--24"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        :fill="avBrandPrimary"
        d="M7.5 6a5.5 5.5 0 0 1 5.292 4H20.5a1.5 1.5 0 0 1 0 3H20v1.5a1.5 1.5 0 0 1-3 0V13h-4.208A5.501 5.501 0 0 1 2 11.5 5.5 5.5 0 0 1 7.5 6m0 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
      />
    </svg>
    <svg
      id="m-long-arrow-up--32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 14.4142V21C17 21.5523 16.55228 22 16 22C15.44772 22 15 21.5523 15 21V14.4142L13.70711 15.7071C13.31658 16.0976 12.68342 16.0976 12.29289 15.7071C11.90237 15.3166 11.90237 14.6834 12.29289 14.2929L15.29289 11.2929C15.68342 10.9024 16.31658 10.9024 16.70711 11.2929L19.7071 14.2929C20.0976 14.6834 20.0976 15.3166 19.7071 15.7071C19.3166 16.0976 18.6834 16.0976 18.2929 15.7071L17 14.4142Z"
        :fill="avBrandPrimary"
      />
    </svg>
    <svg
      id="m-datastore-assignment--32"
      viewBox="0 0 16 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 21C13.4477 21 13 20.5523 13 20V12C13 11.4477 13.4477 11 14 11C14.5523 11 15 11.4477 15 12V20C15 20.5523 14.5523 21 14 21Z"
        :fill="avBrandPrimary"
      />
      <path
        d="M11 17H4.41421L6.70711 19.2929C7.09763 19.6834 7.09763 20.3166 6.70711 20.7071C6.31658 21.0976 5.68342 21.0976 5.29289 20.7071L1.29289 16.7071C0.902369 16.3166 0.902369 15.6834 1.29289 15.2929L5.29289 11.2929C5.68342 10.9024 6.31658 10.9024 6.70711 11.2929C7.09763 11.6834 7.09763 12.3166 6.70711 12.7071L4.41421 15H11C11.5523 15 12 15.4477 12 16C12 16.5523 11.5523 17 11 17Z"
        :fill="avBrandPrimary"
      />
    </svg>
    <svg
      id="m-tier-o--24"
      height="24"
      width="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.7018 7.09137C20.5041 6.74899 20.2187 6.46548 19.875 6.27002H19.908L13.158 2.29002C12.8135 2.10005 12.4264 2.00043 12.033 2.00043C11.6396 2.00043 11.2525 2.10005 10.908 2.29002L4.158 6.27002C3.443 6.66302 3 7.40802 3 8.21702V15.502C3.0008 15.9007 3.1087 16.2918 3.31241 16.6345C3.51612 16.9772 3.80817 17.2588 4.158 17.45L10.908 21.72C11.2426 21.9037 11.6182 22.0001 12 22.0001C12.3818 22.0001 12.7574 21.9037 13.092 21.72L19.842 17.45C20.557 17.057 21 16.311 21 15.502V8.21802C21.0025 7.82265 20.8995 7.43376 20.7018 7.09137Z"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        :stroke="avBrandPrimary"
      />
      <path
        d="M10 8H14"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        :stroke="avBrandPrimary"
      />
      <path
        d="M12 8V16"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        :stroke="avBrandPrimary"
      />
    </svg>
    <svg
      id="m-connect-alt--16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 4C6.69199 4 5.53066 4.62676 4.7992 5.60058C4.46751 6.04217 3.84064 6.13126 3.39905 5.79957C2.95747 5.46788 2.86837 4.84101 3.20006 4.39942C4.29302 2.94434 6.03637 2 8 2C10.973 2 13.441 4.16229 13.917 7H15C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9H13.917C13.441 11.8377 10.973 14 8 14C6.03637 14 4.29302 13.0557 3.20006 11.6006C2.86837 11.159 2.95747 10.5321 3.39905 10.2004C3.84064 9.86874 4.46751 9.95783 4.7992 10.3994C5.53066 11.3732 6.69199 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4Z"
        :fill="avBrandPrimary"
      />
      <path
        d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C7.25972 6 6.61337 6.4022 6.26756 7H1C0.447715 7 0 7.44772 0 8C0 8.55228 0.447715 9 1 9H6.26756C6.61337 9.5978 7.25972 10 8 10Z"
        :fill="avBrandPrimary"
      />
    </svg>
  </defs>
</template>

<script>
import {
  avBrandPrimary,
  avBrandLight
} from '@/assets/styles/variables.module.scss';

  export default {
    name: 'ElIconSprite',
    data() {
      return {
        avBrandPrimary,
        avBrandLight
      };
    }
  };
</script>
